/**
 * Apollo TypePolicy keyArgs for GetFinderItems
 * @see https://www.apollographql.com/docs/react/pagination/key-args/#keyargs-array
 */
export const FINDER_ITEM_KEY_ARGS = [
  'flattenFolders',
  'filterStrategy',
  'filters',
  'groupBys',
  'sortBys',
] as const;
